import NextLink from "next/link";
import { Button, CircularProgress, Typography } from "@aph/ui-lib-humanx";
import WhiteRightArrow from "$/icons/icon_WhiteRightArrow.svg";
import { PHONE_MAX_LENGTH } from "@/components/SignIn/constants";
import styles from "./PhoneInout.module.scss";

interface PhoneInputProps {
  name: string;
  isSendingOtp: boolean;
  handlePhoneSubmit: (phone: string) => void;
  handleMobileNumber: (d: string) => void;
  mobileNumber: any;
  errorMessage: string;
}

const PhoneInput: React.FC<PhoneInputProps> = (props: PhoneInputProps) => {
  const { name, isSendingOtp, handlePhoneSubmit, handleMobileNumber, mobileNumber, errorMessage } = props;

  return (
    <div className={styles.phoneInputWrap}>
      <div className={`${styles.titleBx}`}>
        <Typography component="h2" className={`${styles.title}`}>
          Enter your mobile number to login
        </Typography>
      </div>

      <div className={styles.phoneInputBx}>
        <div className={styles.phoneInput}>
          +91{" "}
          <input
            className={styles.input}
            name={name}
            type="tel"
            maxLength={PHONE_MAX_LENGTH}
            value={mobileNumber}
            autoComplete="on"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleMobileNumber(e.target.value.replace(/\D/g, ""))}
          />
          {errorMessage && (
            <Typography component="p" className={`${`${styles.errorMsg} ${styles.wrongPhoneNum}`}`}>
              {errorMessage}
            </Typography>
          )}
        </div>
        <Button
          className={styles.btn}
          title={"Login"}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e?.preventDefault();
            handlePhoneSubmit(mobileNumber);
          }}
          disabled={isSendingOtp}
        >
          {isSendingOtp ? (
            <CircularProgress width={60} height={60} color="secondary" className={styles.loader} />
          ) : (
            <WhiteRightArrow />
          )}
        </Button>
      </div>

      <div className={`${styles.extraInfo}`}>
        <Typography component="p" className={styles.subText}>
          OTP will be sent to this number by SMS and WhatsApp
        </Typography>
        <Typography component="p" className={styles.subText}>
          By signing up, I agree to the{" "}
          <NextLink target="_blank" href={"/privacy-policy"} prefetch={false}>
            Privacy Policy
          </NextLink>
          ,{" "}
          <NextLink target="_blank" href={"/terms"} prefetch={false}>
            Terms and Conditions
          </NextLink>{" "}
          of Apollo Pharmacy
        </Typography>
      </div>
    </div>
  );
};

export default PhoneInput;
